import { useState, useEffect } from 'react';

export default function PremiumBadge({ user, message, visible }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (visible) setShow(true);
    else setShow(false);
  }, [visible]);

  // Only show the message for free users when visible
  if (!visible || !user || user.plan !== "free") return null;


  return (
    <div
      className="alert alert-warning text-center mb-3"
      style={{ transition: 'all 0.5s ease', opacity: show ? 1 : 0 }}
    >
      {message}
    </div>
  );
}
